import { useBrPageContext } from "../../context/context/context.js";
import { getBrPageContent } from "../../utils/utils/get-br-page-content.js";
const mapButtonStyle = (buttonStyle = "") => {
  const [colorMap, variantMap] = buttonStyle.split(" ");
  const color = colorMap;
  const variant = variantMap;
  return {
    color,
    variant
  };
};
const emptyContentBlock = {
  contentBlock: void 0,
  color: void 0,
  variant: void 0
};
const useGetCtaButtonComponent = () => {
  const page = useBrPageContext();
  if (!page) {
    return emptyContentBlock;
  }
  const mainDocumentReference = page.getComponent("main", "content")?.getModels().document;
  if (!mainDocumentReference) {
    return emptyContentBlock;
  }
  if (!mainDocumentReference.$ref) {
    return emptyContentBlock;
  }
  const ctaButtonContentBlock = getBrPageContent(
    page,
    mainDocumentReference
  )?.ctabuttonCompound;
  const { color, variant } = mapButtonStyle(ctaButtonContentBlock?.buttonStyling);
  return { contentBlock: ctaButtonContentBlock, color, variant };
};
export {
  useGetCtaButtonComponent
};
//# sourceMappingURL=use-get-cta-button-component.js.map
